import {
    optionsCheckpoint,
    timerCheckpoint,
    delayCheckpoint
} from "@modules/JourneyBuilder/Bricks/Checkpoints";

import {
    sanitizeText,
    withPropertyBasedConnections,
    withWhitelistedCheckpointTypes
} from "./brick-initializer-helpers";

/**
 * Initialize the given AB brick
 * @param {JourneyBrick} brick
 */
const initialize = brick => {
    const _registerConnection = brick.registerConnection;
    brick.registerConnection = function(connection) {
        _registerConnection.apply(this, arguments);
        
        if(connection.sourceBrick !== brick) {
            return;
        }

        //https://datanext.atlassian.net/browse/DPN-3576
        //AB brick connections outgoing connections only accept options, timer, and delay checkpoints
        withWhitelistedCheckpointTypes(connection, [
            optionsCheckpoint,
            timerCheckpoint,
            delayCheckpoint
        ]);
    }
    
    withPropertyBasedConnections(brick, {
        brickConfigProperty: 'routes',
        canDeleteConnection: connection => connection.id !== brick.config.leftoversConnectionId,
        onConnectionUpdated: (connection, route) => {
            const ui = connection.ui;
            
            ui.borderColor = route.color;
            ui.tooltip.title = `${route.percentage}%`;
            ui.tooltip.content = sanitizeText(route.description);
        }
    });
}

export {
    initialize
}